import React from 'react';
import { Link, Icon } from '@landing/ui';

import * as styles from './SocialMediaIcon.module.scss';

export default function SocialMediaIcon() {
  return (
    <>
      <Link href="https://www.instagram.com/andersen.global/" className={styles.link}>
        <Icon name="instagram" className={styles.icon} aria-label="Instagram link" />
      </Link>
      <Link href="https://t.me/andersenpoland" className={styles.link}>
        <Icon name="telegram" className={styles.icon} aria-label="Telegram link" />
      </Link>
      <Link href="https://www.facebook.com/AndersenSoftwareDev" className={styles.link}>
        <Icon name="facebook" className={styles.icon} aria-label="Facebook link" />
      </Link>
      <Link href="https://twitter.com/AndersenLabs" className={styles.link}>
        <Icon name="twitter" className={styles.icon} aria-label="Twitter link" />
      </Link>
    </>
  );
}
